<template>
  <form class="feedback-form">
    <div class="feedback-form__fields">
      <Input class="feedback-form__name" :status="errors.name ? 'error': ''" label="Ваше имя" placeholder="Имя"
        v-model="name" required />
      <Input class="feedback-form__phone" :status="errors.phone ? 'error': ''" label="Ваш телефон" placeholder="Телефон"
        v-model="phone" v-maska="'+7 (###) ###-##-##'" required />
      <Input class="feedback-form__text" :status="errors.text ? 'error': ''" label="Отзыв" placeholder="Отзыв"
        v-model="text" required />
    </div>
    <div class="feedback-form-control">
      <Button class="feedback-form__bnt" @click.prevent="submit">{{ getValue('bnt') }}</Button>
      <p class="feedback-form__desc">Нажимая “{{ getValue('bnt') }}” вы даете согласие на обработку персональных
        данных</p>
    </div>
  </form>
</template>

<script>
import Input from "@/components/element/InputApp.vue";
import Button from "@/components/element/ButtonApp.vue";
import { getValue } from '@/helpers/index.js';
import { validation } from "@/helpers/index.js";

export default {
  name: 'FeedbackForm',
  components: {
    Input,
    Button,
  },
  props: {
    content: {
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      name: "",
      phone: "",
      text: "",
      errors: {
        name: false,
        phone: false,
        text: false,
      }
    }
  },
  computed: {
    getValue() {
      return (path) => {
        return getValue(this.content, path, "");
      }
    },
  },
  methods: {
    submit() {
      let isSubmit = true;
      this.errors = { name: false, phone: false, text: false };

      if (!validation(this.name, null)) {
        this.errors.name = true;
        isSubmit = false;
      }

      if (!validation(this.phone, 'phone')) {
        this.errors.phone = true;
        isSubmit = false;
      }

      if (!validation(this.text, null)) {
        this.errors.text = true;
        isSubmit = false;
      }

      if (isSubmit) {
        this.$store.dispatch("submitForm", {
          id: 769,
          custom_name: this.name,
          custom_phone: this.phone,
          custom_feedback: this.text,
        });

        this.$store.commit('updatePopup', {
          status: 'success',
          data: this.getValue('success')
        });

        let context = this;

        setTimeout(() => {
          context.$store.commit('updateClose', null);
        }, 2000)
      }
    }
  },
  mounted() {
    console.log(this.getValue('success'));
  }
};
</script>
<style>
.feedback-form__fields {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 50px;
}

.feedback-form__name {
  width: 47%;
  margin-bottom: 40px;
}

.feedback-form__phone {
  width: 47%;
  margin-bottom: 40px;
}

.feedback-form__text {
  width: 100%;
}

.feedback-form-control {
  display: flex;
  align-items: center;
}

.feedback-form__bnt {
  margin-right: 100px;
}

.feedback-form__desc {
  width: 362px;

  font-size: 14px;
  color: #858993;
}

@media screen and (max-width: 1919.98px) {
  .feedback-form__fields {
    margin-bottom: 45px;
  }

  .feedback-form__bnt {
    margin-right: 75px;
  }

  .feedback-form__desc {
    width: 300px;
  }
}

@media screen and (max-width: 1599.98px) {
  .feedback-form__fields {
    margin-bottom: 40px;
  }

  .feedback-form__quantity {
    margin-bottom: 25px;
  }

  .feedback-form__date {
    margin-bottom: 25px;
  }

  .feedback-form__time {
    margin-bottom: 25px;
  }

  .feedback-form__bnt {
    margin-right: 58px;
  }

  .feedback-form__desc {
    width: 240px;

    font-size: 12px;
  }
}

@media screen and (max-width: 1199.98px) {
  .feedback-form__fields {
    margin-bottom: 35px;
  }

  .feedback-form__quantity {
    margin-bottom: 20px;
  }

  .feedback-form__date {
    margin-bottom: 20px;
  }

  .feedback-form__time {
    margin-bottom: 20px;
  }

  .feedback-form__desc {
    font-size: 10px;
  }
}

@media screen and (max-width: 991.98px) {
  .feedback-form__fields {
    margin-bottom: 30px;
  }

  .feedback-form__fields {
    flex-direction: column;
  }

  .feedback-form__quantity {
    width: 100% !important;
  }

  .feedback-form__date {
    width: 100%;
  }

  .feedback-form__time {
    width: 100%;
  }

  .feedback-form__name {
    width: 100%;
    margin-bottom: 20px;
  }

  .feedback-form__phone {
    width: 100%;
  }

  .feedback-form-control {
    flex-direction: column;
    align-items: flex-start;
  }

  .feedback-form__bnt {
    margin-right: 0;
    margin-bottom: 15px;
  }
}

@media screen and (max-width: 767.98px) {
  .feedback-form__fields {
    margin-bottom: 25px;
  }
}
</style>
